import React from "react";

function Clock_Intro() {
  return (
    <div>
      <h1>Clock_Intro Component</h1>
      <p>This is the Clock Intro tutorial page content.</p>
    </div>
  );
}

export default Clock_Intro;
